import { usePermissions, readStoredEmployee } from "@/hooks/usePermissions";

// <Can k="settings.database-mgmt.backup.restore">…</Can> — renders children only when the
// logged-in role is granted that Access Control key (see backend/access_catalog.py).
// Hidden, not disabled — per the owner's spec. `fallback` optional.
export function Can({ k, employee, fallback = null, children }) {
  const emp = employee || readStoredEmployee();
  const { can } = usePermissions(emp);
  return can(k) ? children : fallback;
}

export function useCan(employee) {
  const emp = employee || readStoredEmployee();
  return usePermissions(emp).can;
}

export default Can;
